import { useMutation, useQuery, useQueryClient } from "react-query";
import axios from "axios";
import { message } from "antd";
import { useAuthStore } from "../../stores/useAuthStore";

export function useProducts(data: { skip?: number; take?: number; keyword?: string }) {
  const authStore = useAuthStore();

  return useQuery(["products", data], async () => {
    if (!authStore.token) return;

    const response = await axios.get<{ cars: []; total: number }>(`/backend/admin/cars`, {
      params: data,
    });

    return response.data;
  });
}

export function useProductDetail() {
  return useMutation(
    ["productDetail"],
    (data: { id: number | string }) => {
      return axios.get(`/backend/admin/cars/${data.id}`);
    },
    {
      onSuccess: () => {},
    }
  );
}

export function useDeleteProduct() {
  const queryClient = useQueryClient();

  return useMutation(
    ["product", "delete"],
    (id: string | number) => {
      return axios.delete(`/backend/admin/cars`, { data: { ids: [id] } });
    },
    {
      onSuccess: () => {
        message.success("刪除成功");
        queryClient.invalidateQueries("products");
      },
    }
  );
}
